import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { formatWhatsAppText } from '../../../TicketDetailView/utils';

const WelcomeWhatsAppPreview = ({ isDark, nombreCompleto, previewPrefix, customMessage }) => {
    const now = new Date();
    const timeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    const hasCustomText = Boolean(customMessage && customMessage.trim().length > 0);

    return (
        <div
            className="card border shadow-sm rounded-3 h-100"
            style={{
                backgroundColor: isDark ? '#121e2d' : '#ffffff',
                borderColor: isDark ? '#233142' : '#e2e8f0'
            }}
        >
            <div
                className="card-header py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{
                    backgroundColor: isDark ? '#162232' : '#f8fafc',
                    borderColor: isDark ? '#233142' : '#e2e8f0'
                }}
            >
                <div className="d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faMobileAlt} className="text-success" />
                    <span className="fw-semibold small" style={{ color: isDark ? '#f1f5f9' : '#1e293b' }}>
                        Vista Previa en WhatsApp
                    </span>
                </div>
                <span className="badge bg-success bg-opacity-10 text-success border border-success px-2 py-0.5" style={{ fontSize: '0.72rem' }}>
                    En Vivo
                </span>
            </div>

            <div className="card-body p-4 d-flex flex-column">
                <p className="text-muted small mb-3" style={{ fontSize: '0.8rem' }}>
                    Así es exactamente como recibirá el cliente el mensaje en su teléfono al momento de tomar el ticket:
                </p>

                {/* Pantalla Simulada de Chat WhatsApp */}
                <div
                    className="p-3 rounded-3 flex-grow-1 d-flex flex-column justify-content-center"
                    style={{
                        backgroundColor: isDark ? '#0b141a' : '#efeae2',
                        backgroundImage: isDark
                            ? 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 0)'
                            : 'radial-gradient(rgba(0,0,0,0.04) 1px, transparent 0)',
                        backgroundSize: '16px 16px',
                        minHeight: '260px'
                    }}
                >
                    {/* Burbuja WhatsApp */}
                    <div
                        className="p-3 rounded-3 shadow-sm position-relative"
                        style={{
                            maxWidth: '92%',
                            alignSelf: 'flex-start',
                            backgroundColor: isDark ? '#005c4b' : '#ffffff',
                            color: isDark ? '#e9edef' : '#111b21',
                            borderRadius: '8px 8px 8px 0px',
                            border: isDark ? '1px solid #005c4b' : '1px solid #e0e0e0',
                            fontSize: '0.88rem',
                            lineHeight: '1.5'
                        }}
                    >
                        {/* Remitente */}
                        <div
                            className="fw-bold mb-1"
                            style={{
                                fontSize: '0.76rem',
                                color: isDark ? '#25d366' : '#075e54'
                            }}
                        >
                            {nombreCompleto || 'Asesor Soporte'} • Akasia
                        </div>

                        {/* Prefijo Institucional Fijo */}
                        <div className={hasCustomText ? 'mb-2 fw-semibold' : 'fw-semibold'} style={{ opacity: 0.95 }}>
                            {formatWhatsAppText(previewPrefix)}
                        </div>

                        {/* Saludo Opcional del Asesor */}
                        {hasCustomText && (
                            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {formatWhatsAppText(customMessage)}
                            </div>
                        )}

                        {/* Hora y Doble Check Azul */}
                        <div
                            className="d-flex justify-content-end align-items-center gap-1 mt-1 text-muted"
                            style={{ fontSize: '0.68rem', color: isDark ? '#8696a0' : '#667781' }}
                        >
                            <span>{timeStr}</span>
                            <span style={{ color: '#53bdeb', fontWeight: 'bold' }}>✓✓</span>
                        </div>
                    </div>
                </div>

                <div className="mt-3 p-2.5 rounded-2 border text-center" style={{ backgroundColor: isDark ? '#162232' : '#f8fafc', borderColor: isDark ? '#233142' : '#e2e8f0' }}>
                    <small className="text-muted" style={{ fontSize: '0.74rem' }}>
                        💡 Tu nombre de asesor se incluye automáticamente en el prefijo institucional al enviar el saludo.
                    </small>
                </div>
            </div>
        </div>
    );
};

export default WelcomeWhatsAppPreview;
